<template>
  <div>
    <input-text v-if="type === 'text'" :name="name" :label="label" :meta="meta" @input-text-change="handleChange"/>
    <input-select v-if="type === 'select'" :name="name" :label="label" :meta="meta" @input-select-change="handleChange" />
    <input-file v-if="type === 'file'" :name="name" :label="label" :meta="meta" @input-file-change="handleChange" />
  </div>
</template>

<script>
import TextInput from './inputs/Text'
import SelectInput from './inputs/Select'
import FileInput from './inputs/File'

export default {
  components: {
    'input-text': TextInput,
    'input-select': SelectInput,
    'input-file': FileInput
  },
  props: ['type', 'name', 'label', 'meta'],
  methods: {
    handleChange (meta) {
      this.$emit('d-input-change', {name: meta.name, value: meta.value})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DynamicInput.vue